import type { ExchangeRatesSnapshot } from "../../../services/exchangeService";
import { formatKrw } from "../../../services/exchangeService";
import styles from "./StatusCards.module.css";

interface ExchangeRatesCardProps {
  snapshot: ExchangeRatesSnapshot | null;
  loading?: boolean;
  error?: string | null;
  className?: string;
}

const CODE_CLASS: Record<string, string> = {
  USD: styles.fxUsd,
  JPY: styles.fxJpy,
  CNY: styles.fxCny,
};

export function ExchangeRatesCard({
  snapshot,
  loading,
  error,
  className,
}: ExchangeRatesCardProps) {
  return (
    <section
      className={[styles.card, className].filter(Boolean).join(" ")}
      aria-label="환율 미·일·중"
    >
      <h2 className={styles.title}>Exchange Rates</h2>

      {loading && !snapshot ? (
        <p className={styles.widgetHint}>환율 불러오는 중…</p>
      ) : error && !snapshot ? (
        <p className={styles.widgetHint}>{error}</p>
      ) : snapshot ? (
        <ul className={styles.alertList}>
          {snapshot.rates.map((r) => (
            <li
              key={r.id}
              className={[styles.fxItem, CODE_CLASS[r.code] ?? ""].join(" ")}
            >
              <span className={styles.fxLabel}>
                <span className={styles.fxCode}>{r.code}</span>
                <span className={styles.fxUnit}>{r.unit}</span>
              </span>
              <span className={styles.alertCount}>{formatKrw(r.krw)}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
